import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCCedric extends NPC {
    constructor() {
        super(definitions.NPC_ID.CEDRIC);

        this.collisionRadius = 10;
        this.collisionOffsetX = -4;
        this.collisionOffsetY = -28;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_cedric_the_jester_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 0.6, new PIXI.Point(-4, -12));
        this.animateIdle(0.55);
    }
}